import axios from "axios";

const loginWithUrl = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "get",
      responseType: "json",
      withCredentials: true,
      params
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => reject(error));
  });
};

export default loginWithUrl;
